import { FirebaseContext } from "@providers/global/firebase"
import { useContext } from "react"

export const useFirebase = () => {
  const { firebase, app, providers, user, db, functions, sale } = useContext(FirebaseContext)
  return { firebase, app, providers, user, db, functions, sale }
}
